// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/Sync/data.graphql
import { gql } from 'Data/Api'

export default gql`
subscription app__App_Account_Content_Settings_Content_ConnectApps_Sync($sync_id: uuid!) {
  apps_sync_by_pk(id: $sync_id) {
    id
    file_url
    metadata
    processingPage: metadata(path: "processing.page")
    matchingPage: metadata(path: "matching.page")
    status
    connection_id
  }
}

`